var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 18C10.0329 18.0046 8.11186 17.418 6.49691 16.3197C4.91915 15.2503 3.70199 13.7464 3 11.9991C3.71023 10.2306 4.94874 8.71247 6.55409 7.6424C8.15945 6.57233 10.0572 6 12 6C13.9428 6 15.8406 6.57233 17.4459 7.6424C19.0513 8.71247 20.2898 10.2306 21 11.9991C20.2983 13.7463 19.0814 15.2502 17.5039 16.3197C15.8887 17.4182 13.9674 18.0048 12 18ZM12 14.3994C11.5145 14.3994 11.04 14.2586 10.6363 13.9949C10.2327 13.7311 9.91807 13.3562 9.7323 12.9176C9.54652 12.479 9.49791 11.9964 9.59262 11.5308C9.68733 11.0651 9.9211 10.6374 10.2644 10.3017C10.6076 9.96605 11.045 9.73744 11.5211 9.64482C11.9973 9.5522 12.4908 9.59973 12.9393 9.78141C13.3878 9.96309 13.7712 10.2708 14.0409 10.6655C14.3106 11.0602 14.4545 11.5243 14.4545 11.9991C14.4545 12.6357 14.1959 13.2462 13.7356 13.6964C13.2753 14.1465 12.651 14.3994 12 14.3994Z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/EyeIcon.e92378aa.svg";
export { ForwardRef as ReactComponent };